/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint react/prop-types: off */
import React, { useState, useEffect } from 'react'
import { FormInput, Button, Popup, FormInputSelect } from 'camino-react'
import { filter, find, includes, map } from 'lodash'

const CSITasks = ({ report, setReport, problemTasks, canEdit }) => {
  const [tasks, setTasks] = useState([])
  const [modalOpen, openModal] = useState(false)

  useEffect(() => setTasks(report.csiTasks), [report.csiTasks])

  const deleteTask = (id) => {
    setTasks(
      prevTasks => (filter(prevTasks, prevTask => (prevTask.id !== id)))
    )
    setReport({ ...report, csiTasks: filter(tasks, prevPart => (prevPart.id !== id)) })
  }

  const addTask = (id) => {
    const task = find(problemTasks, ['id', id])

    setTasks(prevTasks => [...prevTasks, task])
    setReport({ ...report, csiTasks: [...tasks, task] })
    openModal(false)
  }

  const csiTasksOptions = map(filter(problemTasks, task => !includes(tasks, task)), task => (
    { value: task.id, label: `CSI ${task.alt_id}` }
  ))

  return (
    <div className="mt-4">
      <FormInput>
        <table className="">
          <tr className="bg-gray-50">
            <td className="border border-gray-200 p-2 w-1/2">Number</td>
            <td className="border border-gray-200 p-2">Description</td>
            <td className="border border-gray-200 p-2">Due Date</td>
            <td className="border border-gray-200 p-2">Owner</td>
            <td className="border border-gray-200 p-2">Status</td>
            {canEdit && (
              <td className="border border-gray-200 p-2 text-center">
                <span
                  className="lnr lnr-plus-circle text-green-500 align-middle hover:text-green-700 text-3xl"
                  onClick={() => openModal(true)}
                />
              </td>
            )}
          </tr>
          {map(tasks, ({ id, alt_id, description, due_date_humanized, owner, status }, index) => (
            <tr className={index % 2 && 'bg-gray-50'} key={id}>
              <td className="border border-gray-200 p-2 w-1/2">{alt_id}</td>
              <td className="border border-gray-200 p-2">{description}</td>
              <td className="border border-gray-200 p-2">{due_date_humanized}</td>
              <td className="border border-gray-200 p-2">{owner}</td>
              <td className="border border-gray-200 p-2">{status}</td>
              {canEdit && (
                <td className="border border-gray-200 p-2 text-center">
                  <span className="lnr lnr-trash2 lnr-red mt-2 mb-2" onClick={() => deleteTask(id)} />
                </td>
              )}
            </tr>
          ))
          }
        </table>
        <Popup modal open={modalOpen} closeOnDocumentClick={false}>
          <div className="text-gray-600 p-10">
            <div className="flex justify-between mb-10">
              <h3 className="m-0 font-medium mb-2">Add CSI Task</h3>
            </div>

            <FormInput label="CSI Task">
              <FormInputSelect
                options={csiTasksOptions}
                onValue={value => addTask(value)}
              />
            </FormInput>
            <div className="flex justify-center mt-8">
              <Button outline onClick={() => openModal(false)}>Cancel</Button>
            </div>
          </div>
        </Popup>

      </FormInput>
    </div>
  )
}

export default CSITasks
